import { render } from "./WeCare.vue?vue&type=template&id=4226f227&scoped=true"
import script from "./WeCare.vue?vue&type=script&lang=ts"
export * from "./WeCare.vue?vue&type=script&lang=ts"

import "./WeCare.vue?vue&type=style&index=0&id=4226f227&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4226f227"

export default script